import script from "./useSubTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./useSubTitle.vue?vue&type=script&setup=true&lang=js"

import "./useSubTitle.vue?vue&type=style&index=0&id=16aa3add&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16aa3add"]])

export default __exports__